import axios from 'axios';
import {
  loginreq,
  req
} from './axiosFun';

// 登录接口 
export const login = (params) => {
  return loginreq("post", "/admin/login", params)
};
// 获取User信息接口 
export const auth = () => {
  return req("post", "/admin/auth")
};
//Administrator-列表
export const systemUserList = (params) => {
  return req("post", "/admin/system_User/User_list", params)
};
//Administrator-Save
export const systemUserSave = (params) => {
  return req("post", "/admin/system_User/User_save", params)
};
//Administrator-删除
export const systemUserDelete = (params) => {
  return req("post", "/admin/system_User/User_delete", params)
};

//Administrator权限-列表
export const systemUserGroupList = (params) => {
  return req("post", "/admin/system_auth/User_group_list", params)
};
//Administrator权限-Save
export const systemUserGroupSave = (params) => {
  return req("post", "/admin/system_auth/User_group_save", params)
};
//Administrator权限-删除
export const systemUserGroupDelete = (params) => {
  return req("post", "/admin/system_auth/User_group_delete", params)
};

//AdministratorSystem log-列表
export const systemLogList = (params) => {
  return req("post", "/admin/system_log/log_list", params)
};

//图片上传
export const upload = (params) => {
  return req("post", "/admin/upload", params, 'multipart/form-data')
};
//User list
export const businessList = (params) => {
  return req("post", "/admin/business/business_list", params)
};
//Business删除
export const businessDel = (params) => {
  return req("post", "/admin/business/business_del", params)
};
//BusinessSet uplogo
export const setLogo = (params) => {
  return req("post", "/admin/business/set_logo", params)
};
//ResetPassword
export const businessPwdChange = (params) => {
  return req("post", "/admin/business/pwd_change", params)
};
//EditUserType
export const updateState = (params) => {
  return req("post", "/admin/business/update_state", params)
};
//转化率监控
export const adminIndex = (params) => {
  return req("post", "/admin", params)
};
//SIM card列表
export const cardList = (params) => {
  return req("post", "/admin/card/card_list", params)
};
//SIM cardSave
export const cardSave = (params) => {
  return req("post", "/admin/card/save", params)
};
export const cardDel = (params) => {
  return req("post", "/admin/card/del", params)
};
export const cardBatchDel = (params) => {
  return req("post", "/admin/card/batch_del", params)
};
//SIM cardEditStatus
export const updateCardState = (params) => {
  return req("post", "/admin/card/update_state", params)
};
//SIM Removed
export const cardRemoved = (params) => {
  return req("post", "/admin/business/card_removed", params)
};
// SIM card实时余额修改
export const updateCardBalance = (params) => {
  return req("post", "/admin/business/update_card_balance", params)
};
//SIM card列表
export const getCardList = (params) => {
  return req("post", "/admin/business/card_list", params)
};
//BusinessSet upSIM card
export const cardSet = (params) => {
  return req("post", "/admin/business/card_set", params)
};
//BusinessSet upSIM card
export const urlBackList = (params) => {
  return req("post", "/admin/business/url_back_list", params)
};
//BusinessSet upWithdraw优先级
export const transLevelSet = (params) => {
  return req("post", "/admin/business/trans_level_set", params)
};
//Recharge
export const reservedList = (params) => {
  return req("post", "/admin/reserved", params)
};
//Recharge备份
export const reservedBackupsList = (params) => {
  return req("post", "/admin/reserved_backups", params)
};
//Recharge垃圾箱
export const reservedDustbinList = (params) => {
  return req("post", "/admin/reserved_dustbin", params)
};
//Recharge垃圾箱还原
export const reservedReduction = (params) => {
  return req("post", "/admin/reserved_dustbin/reduction", params)
};
//Recharge自动回调
export const reservedCback = (params) => {
  return req("post", "/admin/reserved/cback", params)
};
//Recharge确认收款
export const reservedSucc = (params) => {
  return req("post", "/admin/reserved/succ", params)
};
//Withdraw付Business
export const transBusinessList = (params) => {
  return req("post", "/admin/reserved/business_list", params)
};
//Withdraw
export const transactionList = (params) => {
  return req("post", "/admin/transaction", params)
};
export const transactionBackupsList = (params) => {
  return req("post", "/admin/transaction_backups", params)
};
export const getSmsUser = () => {
  return req("post", "/admin/transaction/get_sms_user")
};
//Withdraw垃圾箱
export const transactionDustbinList = (params) => {
  return req("post", "/admin/transaction_dustbin", params)
};
//Withdrawreject
export const transRejected = (params) => {
  return req("post", "/admin/transaction/rejected", params)
};
//Withdraw自动回调
export const transactionCback = (params) => {
  return req("post", "/admin/transaction/cback", params)
};
export const transactionSucc = (params) => {
  return req("post", "/admin/transaction/succ", params)
};
export const transactionTop = (params) => {
  return req("post", "/admin/transaction/set_top", params)
};
//解除Grab人
export const transactionUnlock = (params) => {
  return req("post", "/admin/transaction/unlock", params)
};
//System变量列表
export const settingList = () => {
  return req("post", "/admin/var_setting/setting_list")
};
//System变量Edit
export const settingSave = (params) => {
  return req("post", "/admin/var_setting/save", params, 'application/json')
};
//短信
export const smsList = (params) => {
  return req("post", "/admin/sms/sms_list", params)
};
//短信
export const smsFile = (params) => {
  return req("post", "/admin/sms/sms_file", params)
};
//短信（新）
export const smsListNew = (params) => {
  return req("post", "/admin/sms/sms_list_new", params)
};
export const smsListOperate = (params) => {
  return req("post", "/admin/sms/sms_list_operate", params)
};
//短信（新）
export const smsListNewBackups = (params) => {
  return req("post", "/admin/sms/sms_list_backups", params)
};
//Other message（新）
export const smsListAuxiNew = (params) => {
  return req("post", "/admin/sms/sms_list_auxi", params)
};
export const smsListOmitNew = (params) => {
  return req("post", "/admin/sms/sms_list_omit", params)
};
//Refund短信（新）
export const smsListReversed = (params) => {
  return req("post", "/admin/sms/sms_list_reversed", params)
};
//APP User
export const smsAppList = (params) => {
  return req("post", "/admin/sms/sms_app_list", params)
};
//APP UserWithdrawReward
export const smsTransReward = (params) => {
  return req("post", "/admin/sms/sms_trans_reward", params)
};
//APP UserSave
export const smsAppSave = (params) => {
  return req("post", "/admin/sms/sms_app_save", params)
};
//APP User删除
export const smsAppDel = (params) => {
  return req("post", "/admin/sms/sms_app_del", params)
};
//APP User删除
export const smsAppGetSocketId = (params) => {
  return req("post", "/admin/sms/get_socket_id", params)
};
//SIM card获取APP User list
export const getSmsUserList = (params) => {
  return req("post", "/admin/sms/card_sms_app_list", params)
};
//SIM card获取APP User list
export const cardSmsUserList = (params) => {
  return req("post", "/admin/card/sms_app_list", params)
};
//SIM card获取APP User list
export const smsAppSet = (params) => {
  return req("post", "/admin/card/sms_app_set", params)
};
//SIM cardResetAPP User list
export const smsAppReset = (params) => {
  return req("post", "/admin/card/sms_app_reset", params)
};
//统计
export const statistics = (params) => {
  return req("post", "/admin/statics", params)
};
//附加信息
export const statisInfos = (params) => {
  return req("post", "/admin/statics/infos", params)
};
//Grab monitoring
export const smsRob = () => {
  return req("post", "/admin/sms/rob")
};
//Business withdrawal列表
export const internalWithdrawal = (params) => {
  return req("post", "/admin/internal/withdrawal_list", params)
};
//Business withdrawal新增
export const internalWithdrawalAdd = (params) => {
  return req("post", "/admin/internal/withdrawal_add", params)
};
//Business withdrawalBusiness list
export const internalBusinessList = () => {
  return req("post", "/admin/internal/business_list")
};
//kaka列表
export const cardTrans = (params) => {
  return req("post", "/admin/internal/card_trans", params)
};
//kakaCard list
export const cardCardList = (params) => {
  return req("post", "/admin/internal/card_list", params)
};
//kaka新增
export const cardCardAdd = (params) => {
  return req("post", "/admin/internal/card_add", params)
};
export const smsQuickCheck = (params) => {
  return req("post", "/admin/sms/quick_check", params)
};
export const orderCheckList = (params) => {
  return req("post", "/admin/check_order", params)
};
export const orderCheckReply = (params) => {
  return req("post", "/admin/check_order/reply", params)
};
export const reservedSave = (params) => {
  return req("post", "/admin/reserved/save", params)
};
export const transactionSave = (params) => {
  return req("post", "/admin/transaction/save", params)
};
export const orderCback = (params) => {
  return req("post", "/admin/check_order/cback", params)
};
export const appCardDel = (params) => {
  return req("post", "/admin/sms/app_card_del", params)
};
export const assignRobber = (params) => {
  return req("post", "/admin/sms/assign_robber", params)
};
export const businessBill = (params) => {
  return req("post", "/admin/business/bill_list", params)
};
export const updateFlag = (params) => {
  return req("post", "/admin/sms/set_flag", params)
};
export const messageCallback = (params) => {
  return req("post", "/admin/sms/message_callback", params)
};
export const resendCallback = (params) => {
  return req("post", "/admin/sms/message_resend", params)
};
export const rematchOrders = (params) => {
  return req("post", "/admin/sms/message_rematch", params)
};
//回调备份
export const urlBackBackupsList = (params) => {
  return req("post", "/admin/business/url_back_backups_list", params)
};
//withdrawal短信匹配
export const smsDisburse = (params) => {
  return req("post", "/admin/sms/sms_disburse", params)
};
//WithdrawOrdersAdd未匹配的短信
export const addMessageTransation = (params) => {
  return req("post", "/admin/transaction/add_message", params)
};
export const getBussCard = (params) => {
  return req("post", "/admin/transaction/get_buss_card", params)
};
//Reset佣金
export const rateSucc = (params) => {
  return req("post", "/admin/reserved/rate_change", params)
};
//EditAutomatic Status
export const updateAutoTrans = (params) => {
  return req("post", "/admin/business/update_auto_trans", params)
};

export const updateCardResolve = (params) => {
  return req("post", "/admin/card/update_resolve", params)
};

//Country列表
export const countryList = () => {
  return req("post", "/admin/sms/country_list")
};
//Agent
export const agentList = (params) => {
  return req("post", "/admin/agent/agent_list", params)
};
export const agentSave = (params) => {
  return req("post", "/admin/agent/agent_save", params)
};
//Cardholder
export const opencardList = (params) => {
  return req("post", "/admin/opencard/opencard_list", params)
};

export const opencardSave = (params) => {
  return req("post", "/admin/opencard/opencard_save", params)
};
//Country
export const bdCountryList = (params) => {
  return req("post", "/admin/country/country_list", params)
};
export const bdCountrySave = (params) => {
  return req("post", "/admin/country/country_save", params)
};
//businessBalanceList
export const businessBalanceList = (params) => {
  return req("post", "/admin/business_balance/balance_list", params)
};
export const businessBalanceSave = (params) => {
  return req("post", "/admin/business_balance/balance_save", params)
};
//Operator
export const operatorList = (params) => {
  return req("post", "/admin/operator/operator_list", params)
};
export const operatorSave = (params) => {
  return req("post", "/admin/operator/operator_save", params)
};
//SIM card附加信息
export const cardAttachList = () => {
  return req("post", "/admin/card/attach_list")
};
//balance_reminder
export const cardBalanceReminderSave = (params) => {
  return req("post", "/admin/card/balance_reminder", params)
};
//获取CountryBusiness级联数据
export const getCountryBusiness = () => {
  return req("post", "/admin/statics/get_country_business")
};
//Withdraw单Reject callback
export const rejectedCallback = (params) => {
  return req("post", "/admin/transaction/rejected_callback", params)
};
//Add SMS
export const smsAdd = (params) => {
  return req("post", "/admin/sms/sms_add", params)
};
//

export const transactionSmsUser = (params) => {
  return req("post", "/admin/transaction/sms_user", params)
};
export const smsCancelCallback = (params) => {
  return req("post", "/admin/sms/cancel_callback", params)
};
export const AutomaticAppList = (params) => {
  return req("post", "/admin/automatic_app/automatic_app_list", params)
};
export const AutomaticAppSave = (params) => {
  return req("post", "/admin/automatic_app/automatic_app_save", params)
};
export const AccessPermission = () => {
  return req("post", "/admin/access_permission",)
};
export const AppTransferBusiness = (params) => {
  return req("post", "/admin/sms/app_transfer_business", params)
};
export const SetAppTransferBusiness = (params) => {
  return req("post", "/admin/sms/set_app_transfer_business", params)
};
export const countryBlur = (params) => {
  return req("post", "/admin/transaction/country_blur", params)
};
export const businessBlur = (params) => {
  return req("post", "/admin/transaction/business_blur", params)
};
export const auxiTag = (params) => {
  return req("post", "/admin/sms/auxi_tag", params)
};
export const smsDevDone = (params) => {
  return req("post", "/admin/sms/dev_done", params)
};
export const smsCheck = (params) => {
  return req("post", "/admin/sms/to_check", params)
};
export const getNearbySms = (params) => {
  return req("post", "/admin/sms/nearby", params)
};
export const cardDesc = (params) => {
  return req("post", "/admin/card/set_desc", params)
};
export const transOperator = (params = {}) => {
  return req("post", "/admin/transaction/trans_operator", params)
};
export const setSmsTagCheck = (params = {}) => {
  return req("post", "/admin/sms/tag_check", params)
};
export const businessChart = (params = {}) => {
  return req("post", "/admin/business/chart", params)
};
export const transfersBatchAssign = (params = {}) => {
  return req("post", "/admin/transaction/batch_assign", params)
};
export const transfersBatchUnlock = (params = {}) => {
  return req("post", "/admin/transaction/batch_unlock", params)
};
export const changeBusinessAutomatic = (params = {}) => {
  return req("post", "/admin/business/change_automatic", params)
};
export const removeException = (params = {}) => {
  return req("post", "/admin/transaction/remove_exception", params)
};
export const addSms = (params = {}) => {
  return req("post", "/admin/transaction/add_sms", params)
};

export const withdrawalList = (params = {}) => {
  return req("post", "/admin/withdrawal_records/withdrawal_list", params)
};
export const withdrawalSave = (params = {}) => {
  return req("post", "/admin/withdrawal_records/withdrawal_save", params)
};
export const withdrawalDelete = (params = {}) => {
  return req("post", "/admin/withdrawal_records/withdrawal_delete", params)
};
export const lockCardList = (params = {}) => {
  return req("post", "/admin/lock_card/lock_card_list", params)
};
export const lockCardSave = (params = {}) => {
  return req("post", "/admin/lock_card/lock_card_save", params)
};
export const lockCardDelete = (params = {}) => {
  return req("post", "/admin/lock_card/lock_card_delete", params)
};

export const getCardByBusiness = (params = {}) => {
  return req("post", "/admin/lock_card/get_card_by_business", params)
};

export const exchangeRateDiffList = (params = {}) => {
  return req("post", "/admin/exchange_rate_diff/exchange_rate_diff_list", params)
};
export const exchangeRateDiffSave = (params = {}) => {
  return req("post", "/admin/exchange_rate_diff/exchange_rate_diff_save", params)
};
export const exchangeRateDiffDelete = (params = {}) => {
  return req("post", "/admin/exchange_rate_diff/exchange_rate_diff_delete", params)
};

export const internalRechargeOptions = () => req("post", "/admin/internal_recharge/business_options");
export const internalRechargeList = (params = {}) => req("post", "/admin/internal_recharge/recharge_list", params);
export const internalRechargeSave = (params = {}) => req("post", "/admin/internal_recharge/recharge_save", params);
export const internalRechargeReverse = (params = {}) => req("post", "/admin/internal_recharge/recharge_reverse", params);



// WEBPACK FOOTER //
// ./src/api/apiFun.js